export const isNonSaudiApplicantUser = (user) => {
  if (!user) {
    return false;
  }

  const context = String(user.account_context || user.auth_context || "").toLowerCase();
  if (context === "non_saudi_applicant") {
    return true;
  }

  const status = String(user.registration_status || "").toLowerCase();
  return !!user.registration_request_public_id && ["pending_review", "rejected"].includes(status);
};

export const getNonSaudiApplicantContinuePath = (user) => {
  const status = String(user?.registration_status || "").toLowerCase();
  return status === "approved" ? "/subscribe" : "/registration/status";
};

